// @flow

import * as React from 'react';

type Props = {|
  css?: any,
  className?: string,
  onClick: () => void,
  children: React.Node,
|};

export const Clear = (props: Props): React.Node => {
  return (
    <div
      className={props.className}
      css={{
        cursor: 'pointer',
        '&:hover': {
          filter: 'brightness(1.5)',
        },
      }}
      onClick={props.onClick}
    >
      {props.children}
    </div>
  );
};
